/*
 * @Description: 中文说明
 * @Author: l_hc
 * @LastEditors: l_hc
 * @Date: 2019-07-02 21:02:40
 * @LastEditTime: 2019-07-24 14:56:53
 */
import { logistice } from '@/utils/request'
import { LOGISTICE_GATEWAY } from '@/utils/settings' // 请求接口

//  我的邀请管理接口Url
const InvitationUrl = '/website/warehousing/invitation/supplyList'

/* 获取地址接口 */
const getAreaUrl = `/sys/sysArea/find`

/* 查询字典接口 */
const getDictUrl = `/sys/dict/getDict`

// 获取字典接口
export function getDict(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + getDictUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'getListByType',
        type: param,
        hasAll: 'no'
      }))
    }
  })
}

// 分页查询普通仓库列表
export function findPageInvitation(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + InvitationUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findMyInvitationList'
      }, param))
    }
  })
}
// 获取地址接口
export function getArea(param) {
  return logistice({
    url: LOGISTICE_GATEWAY + getAreaUrl,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findTreeData'
      }, param))
    }
  })
}
